var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-image"},[_c('div',{staticClass:"v-image__image",class:_vm.classes,style:(_vm.styles)},[_c('picture',{attrs:{"srcset":_vm.srcset}},[_c('img',{style:(_vm.aspectStyle),attrs:{"src":_vm.src,"alt":_vm.alt}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }